import React, { useContext } from 'react'
import ContextStore from '../context/Context';
import { apiResponse } from '../utils/Helper';
import { postData } from '../components/AuthGard/LogGard';

const GoogleLoginService = () => {
    const { setIsLoader } = useContext(ContextStore);
    const handleGoogleSuccess = async (response) => {
        try {
            setIsLoader(true);
            if (!response?.credential) {
                throw new Error("Empty Google credential received");
            }
            let json = {
                credential: response?.credential,
            };
            let res = await apiResponse(await postData("/login/google", json));

            if (res?.success) {
                setIsLoader(false);
                localStorage.setItem("kizoStudyToken", JSON.stringify(res?.data));
                setTimeout(() => {
                    window.location.replace("/");
                }, 2000);
            } else {
                setIsLoader(false);
                alert("Login failed: " + res?.message || "Unknown error");
            }
        } catch (error) {
            setIsLoader(false);
            console.error("Google Login Backend Error:", error);
            alert("Something went wrong during login. Please try again.");
        }
    };
    return { handleGoogleSuccess }
}

export default GoogleLoginService
